module.exports = __webpack_public_path__ + "img/madagascar.86f8e095.svg";